'use client'

import { useEffect } from 'react'
import { useSearchParams, useRouter, usePathname } from 'next/navigation'
import { useToast } from '@/hook/use-toast'

// After a signup that auto-completes a pending follow (see
// app/auth/join-culineer/page.tsx), that flow does a hard page reload, so it
// can't show the toast itself — it flags success via `?followed=true` on the
// landing URL instead. This picks that flag up on arrival, shows the toast
// once, then strips the param so it doesn't repeat on refresh/back-nav.
export default function FollowedToast() {
  const searchParams = useSearchParams()
  const router = useRouter()
  const pathname = usePathname()
  const { toast } = useToast()

  useEffect(() => {
    if (searchParams.get('followed') !== 'true') return

    toast({ title: 'Following', description: "You're now following that account." })

    const params = new URLSearchParams(searchParams.toString())
    params.delete('followed')
    const query = params.toString()
    router.replace(query ? `${pathname}?${query}` : pathname, { scroll: false })
  }, [searchParams, pathname, router, toast])

  return null
}
